<div class="card-headline">
    <div class="header-content">
        <h3>{{ Current?.DisplayName }}</h3>
    </div>
</div>

<div mat-dialog-content class="dialog-content" *ngIf="Current as entry" [formGroup]="entry.FormGroup">
    <mat-form-field style="width: 100%">
        <mat-label>Kostenstellenart</mat-label>
        <mat-select formControlName="Kostenstellenart" required>
            <mat-option *ngFor="let option of KostenstellenartOptions" [value]="option.Id">
                {{ option.Name }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="entry.FormGroup.get('Kostenstellenart').invalid">Pflichtfeld</mat-error>
    </mat-form-field>

    <mat-form-field style="width: 100%">
        <mat-label>{{cls.getSingle$('Department') | async}}</mat-label>
        <mat-select formControlName="DepartmentId" required>
            <mat-option *ngFor="let option of DepartmentOptions$ | async" [value]="option.Id">
                {{ option.Name }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="entry.FormGroup.get('DepartmentId').invalid">Pflichtfeld</mat-error>
    </mat-form-field>

    <mat-form-field style="width: 100%">
        <app-select-search
            [placeholder]="'Bauleiter'"
            [formControl]="entry.FormGroup.controls.BauleiterUserId"
            [Options]="UserOptions$ | async"
            [OptionTemplate]="userTemplate"
          >
        </app-select-search>
        <ng-template #userTemplate let-user>
            {{ user.DisplayName }}
        </ng-template>
        <mat-error *ngIf="entry.FormGroup.get('BauleiterUserId').invalid">Pflichtfeld</mat-error>
    </mat-form-field>
</div>

<div class="pager" *ngIf="IsMultiple">
    <span>{{ cls.getSingle$('Commission') | async }} {{ CurrentIndex + 1 }} von {{ Entries.length }}</span>
</div>

<mat-dialog-actions class="actions">
    <button app-button Inverted Color="cancel" (click)="Cancel()">
        Abbrechen
    </button>

    <button
        *ngIf="CurrentIndex < Entries.length - 1"
        app-button
        [Disabled]="!CurrentValid"
        (click)="Next()">
        Weiter
    </button>

    <button
        *ngIf="CurrentIndex === Entries.length - 1"
        app-button
        Color="green"
        [Disabled]="!AllValid"
        (click)="Save()">
        Speichern
    </button>
</mat-dialog-actions>
